module.exports = __webpack_public_path__ + "./favicons/android-icon-36x36.png";